type StringPropertyKeys<T> = {
  [K in keyof T]-?: T[K] extends string | null | undefined ? K : never;
}[keyof T];

export class SortUtil {
  static sortByStringProperty<T>(items: T[], key: StringPropertyKeys<T>): T[] {
    return items.sort((a, b) => {
      const valueA = (a[key] ?? '') as string;
      const valueB = (b[key] ?? '') as string;

      return valueA.localeCompare(valueB, 'es', { sensitivity: 'base' });
    });
  }
}
